export default {
      id: "18_yas-usage",
      viewBox: "0 0 30 30",
      url: "/" + "images/icons.3.109.2.svg#18_yas-usage",
      toString: function () {
        return this.url;
      }
    }